<template>
    <v-chart ref="pie" :options="option"/>
</template>

<script>
    import ECharts from 'vue-echarts'
    import 'echarts/lib/chart/line'
    export default {
        name: "UserFeaturePieECharts",
        components: {
            'v-chart': ECharts,
        },
        props:{
            pieData:Object
        },
        watch:{
          pieData:function (newVal,oldVal) {
              this.option.legend.data = newVal.settings.legend;
              this.option.series[0].data = newVal.data;
              this.loaded()
          }
        },
        data(){
            return {
                option: {
                    title:{
                        text:'阶段分布',
                        // left: 'center',
                        // top: '10%',
                        bottom:'0%'
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: '{b} : {c} ({d}%)'
                    },
                    legend: {
                        // orient: 'vertical',
                        type:"scroll",
                        left: '0',
                        // data: ['小学生', '初中生', '大学生','研究生','博士','上班族','自由中','保密','未知']
                        data: []
                    },
                    series: [
                        {
                            name: '新增类型',
                            type: 'pie',
                            radius: '80%',
                            center: ['50%', '55%'],
                            legend:{},
                            label: {
                                position: 'inner',
                                formatter: '{d}%'
                            },
                            data: [
                                // {value: 10, name: '小学生'},
                                // {value: 1, name: '初中生'},
                                // {value: 45, name: '大学生'},
                                // {value: 45, name: '研究生'},
                                // {value: 45, name: '博士'},
                                // {value: 45, name: '上班族'},
                                // {value: 45, name: '自由中'},
                                // {value: 45, name: '保密'},
                                // {value: 45, name: '未知'},
                            ],
                            emphasis: {
                                itemStyle: {
                                    shadowBlur: 10,
                                    shadowOffsetX: 0,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                }
                            }
                        }
                    ]
                },

            }
        },
        methods:{
            loading(){
                this.$refs.pie.showLoading()
            },
            loaded(){
                this.$refs.pie.hideLoading()
            }
        }
    }
</script>

<style scoped>
    .echarts{
        width: 100%;
        height: 100%;
    }
</style>